import React, { useState, useEffect } from 'react'
import AdminTop from '../AdminTop'
import AdminNav from '../AdminNav'
import AdminFooter from '../AdminFooter'
import '../../../css/AdminHome.css'
import { Table } from 'react-bootstrap'
// import { noticeList } from '../../../components/NoticeList'
import AddNotice from './AddNotice'
import { useNavigate } from 'react-router-dom'
import EditNotice from './EditNotice'
import DeleteNotice from './DeleteNotice'
import axios from 'axios'

const Pagination = ({ itemsPerPage, Data }) => {

    const [currentPage, setCurrentPage] = useState(1)

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = Data.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(Data.length / itemsPerPage)

    const handlePageClick = (page) => {
        setCurrentPage(page)
    }

    return (
        <>

            <Table responsive hover bordered>
                <thead>
                    <tr>
                        <th>S.N.</th>
                        <th>MESSAGE</th>
                        <th>STATUS</th>
                        <th>OPTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                    <p>{item.message}</p>
                                    <p>{item.detail1}</p>
                                    <p>{item.detail2}</p>
                                    <p>{item.detail3}</p>
                                    <p>{item.detail4}</p>
                                    <p>{item.detail5}</p>
                                    <p>{item.detail6}</p>
                                    <p>{item.detail7}</p>
                                    <p>{item.detail8}</p>
                                    <p>{item.detail9}</p>
                                    <p>{item.detail10}</p>
                                </td>
                                <td>{item.nStatus}</td>
                                <td>
                                    <EditNotice EditNoticeItem={item} />
                                    <DeleteNotice DelID={item.nID} DelStatus={item.nStatus} />
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>

            <div className="pagination">
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => handlePageClick(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>
        </>
    )

}

const NoticesHome = () => {

    const [auth, setAuth] = useState(false)
    const [noticeList, setNoticeList] = useState([])

    const navigate = useNavigate()
    axios.defaults.withCredentials = true

    const fetchNotice = () => {
        axios.get(`${process.env.REACT_APP_BASEURL}/notice`)
            .then(res => {
                if (res.data.status === "Success") {
                    setNoticeList(res.data.noticeDetail)
                }
                else {
                    console.log("Error Getting Data From Backend!!")
                }
            })
    }

    useEffect(() => {

        axios.get(`${process.env.REACT_APP_BASEURL}/`)
            .then(res => {
                if (res.data.status === "Success") {
                    // console.log(res.data)
                    setAuth(true)
                }
                else {
                    setAuth(false)
                    alert(res.data.errorMsg)
                    navigate('/login')
                }
            })

        fetchNotice()

    }, [navigate])

    const sortedNotice = noticeList.sort((a, b) => b.nID - a.nID)

    return (

        <>

            {auth ? <>
                <div className="header-top">
                    <AdminTop />
                </div>

                <div className="header-navbar">
                    <AdminNav />
                </div>

                <div className="home-content1">
                    <div className="content-top">
                        <div className="content-top-left">
                            <input type="text" placeholder='Search...' className='content-search' />
                            <i className="bi bi-search" />
                        </div>
                        <div className="content-add">
                            {/* <button className="content-add-button">+ Add Notice</button> */}
                            <AddNotice />
                        </div>
                    </div>
                    <div className="content-body">
                        <div className="content-body-title">
                            <h3>Notice List</h3>
                        </div>
                        <div className="content-body-list">
                            <Pagination itemsPerPage={6} Data={sortedNotice} />
                        </div>
                    </div>
                </div>

                <div className="footer-links">
                    <AdminFooter />
                </div>
            </> : ""}

        </>

    )
}

export default NoticesHome
